import { render, staticRenderFns } from "./changePassword-list.vue?vue&type=template&id=a0736908&scoped=true"
import script from "./changePassword-list.vue?vue&type=script&lang=js"
export * from "./changePassword-list.vue?vue&type=script&lang=js"
import style0 from "./changePassword-list.vue?vue&type=style&index=0&id=a0736908&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0736908",
  null
  
)

export default component.exports